import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, takeUntil } from 'rxjs';
import { ComplaintFormService } from '../complaint-form.service';
import { forkJoin, Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { EditorModule } from 'primeng/editor';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonService } from '@app/shared/services/common.service';
import { HttpService } from '@app/@core/services/http.service';

@Component({
  selector: 'app-complaint-download',
  templateUrl: './complaint-download.component.html',
  styleUrls: ['./complaint-download.component.scss'],
  standalone: true,
  imports: [CommonModule,EditorModule,DataGridComponent]
})
export class ComplaintDownloadComponent implements OnInit , OnDestroy {

  complaintId: string = '';
  complaintStatusMessages: any[] = [];
  complaintArchivalStatusMessages: any[] = [];  
  complaintData: any;
  private destroy$ = new Subject<void>();
  @ViewChild('complaintEditor', { read: ElementRef }) complaintEditorEl?: ElementRef;
  witnessesDataGridConfig: DataGridVO = DataGridVO.create({});
  supportingWitnessesDataGrid: DataGridVO = DataGridVO.create({});
  licenseEducatorDataGridConfig: DataGridVO = DataGridVO.create({});
  searchLicenseEducatorDataGridConfig: DataGridVO = DataGridVO.create({});
  complaintNotesGridConfig: DataGridVO = DataGridVO.create({});
  witnessesHeaders: any[] = [];
  supportingWitnessesHeaders: any[] = [];
  licenseEducatorHeaders: any[] = [];
  complaintNotesHeaders: any[] = [];
  visibleColumns: { [key: string]: boolean } = {};
  visibleSupportingColumns: { [key: string]: boolean } = {};
  visibleLicenseEducatorColumns: { [key: string]: boolean } = {};
  visibleComplaintNotesColumns: { [key: string]: boolean } = {};
  visibleSearchLicenseEducatorColumns: { [key: string]: boolean } = {};
  assignToList: any[] = [];
  constructor(
    private complaintFormService: ComplaintFormService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private httpService:HttpService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loadDropdownDataMessages();
    this.loadDashboardHeaders();
    this.assignList();
     this.activatedRoute.paramMap.subscribe(params => {
      this.complaintId = params.get('complaintId') || '';
    });
    const payload = { complaintId: this.complaintId };
    setTimeout(() => {
    this.complaintFormService.fetchComplaintDetails(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.complaintData = response?.data?.data || {};
        this.complaintData.complaintStatusValue = this.complaintStatusMessages.find((item: any) => Number(item.key) === this.complaintData?.complaintStatus)?.value ;
        this.complaintData.complaintArchivalStatusValue = this.complaintArchivalStatusMessages.find((item: any) => Number(item.key) === this.complaintData?.complaintArchivalStatus)?.value ;
        this.complaintData.assignToValue = this.assignToList.find((item: any) => item.id === this.complaintData?.assignee)?.full_name;
        this.loadDataGrids();
        const html = `<p>${response.data?.data?.strDescription}</p>`;
         try { this.cd.detectChanges(); } catch (e) { }
        setTimeout(() => {
          try { this.cd.detectChanges(); } catch (e) { }
          try {
            const el = this.complaintEditorEl?.nativeElement as HTMLElement | undefined;
            if (el) {
              const ql = el.querySelector('.ql-editor') as HTMLElement | null;
              if (ql) {
                ql.innerHTML = html || '';
              }
            }
          } catch (e) { }
        }, 50);
      },
      error: (error) => {
        console.error('Error fetching complaint details:', error);
      }
    });
     }, 2000);
  }
  loadDashboardHeaders() {
    this.commonService
      .getComplaintTabs()
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (headers: any) => {
          console.log('Loaded column metadata:', headers);
          this.witnessesHeaders = headers.witnessHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.witnessesHeaders.push({"dataField":"strWitnessTextData","caption":"Additional Information","label":"Additional Information","allowFiltering":true,"allowSearch":{"isSearchEnable":true , "type":"string"}});
          this.supportingWitnessesHeaders = headers.supportingHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.licenseEducatorHeaders = headers.licenseEducatorHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.complaintNotesHeaders = headers.complaintNotesHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.visibleColumns = {};
          this.visibleSupportingColumns = {};
          this.witnessesHeaders.forEach(header => {
            this.visibleColumns[header.dataField] = true;
          });
          this.supportingWitnessesHeaders.forEach(header => {
            this.visibleSupportingColumns[header.dataField] = true;
          });
          this.licenseEducatorHeaders.forEach(header => {
            this.visibleLicenseEducatorColumns[header.dataField] = true;
            this.visibleSearchLicenseEducatorColumns[header.dataField] = true;
          });
          this.complaintNotesHeaders.forEach(header => {
            this.visibleComplaintNotesColumns[header.dataField] = true;
          });
        },
        error: (error: any) => {
          console.error('Error loading column metadata:', error);
        }
      });
  }
   assignList(){
    this.complaintFormService.getPersonByRole()
    .pipe(take(1),takeUntil(this.destroy$))
    .subscribe({
      next: (response) => {
        this.assignToList = response.data.data;
      }
    });
  }
   private async loadDropdownDataMessages() {
      forkJoin([
        this.httpService.get('/domain/lookup?requestType=COMPLAINT_STATUS'),
        this.httpService.get('/domain/lookup?requestType=COMPLAINT_ARCHIVAL_STATUS')
      ]).subscribe({
        next: (item: any) => {
          this.complaintStatusMessages = item[0]?.data,
          this.complaintArchivalStatusMessages = item[1]?.data
        },
        error: (error: any) => {
          console.error('Error loading dropdown data:', error);
        }
      });
  }

  loadDataGrids() {
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.complaintData?.witnesses || []
    });
    this.supportingWitnessesDataGrid = DataGridVO.create({
      customHeaders: this.supportingWitnessesHeaders,
      visibleColumns: this.visibleSupportingColumns,
      data: this.complaintData?.documentUpload || []
    });
     this.licenseEducatorDataGridConfig = DataGridVO.create({
      customHeaders: this.licenseEducatorHeaders,
      visibleColumns: this.visibleLicenseEducatorColumns,
      data: this.complaintData?.licenseEducator || []
    });
    this.complaintNotesGridConfig = DataGridVO.create({
      customHeaders: this.complaintNotesHeaders,
      visibleColumns: this.visibleComplaintNotesColumns,
      data: this.complaintData?.complaintNotes || []
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
